
const configs = {
  development: {
    BASE_URL: 'https://9vdlvfq8-5000.inc1.devtunnels.ms',
    API_VERSION: '/v1',
    PROJECT_NAME: 'SwiftRamp Dev',
    ENABLE_DEPOSIT_FEATURE: true,
    ENABLE_WITHDRAWAL_FEATURE: true,
    SUPPORT_EMAIL: 'support-dev@swiftramp.in',
    LOG_LEVEL: 'debug',
  },
  production: {
    BASE_URL: 'https://api.swiftramp.in',
    API_VERSION: '/v1', 
    PROJECT_NAME: 'SwiftRamp',
    ENABLE_DEPOSIT_FEATURE: true,
    ENABLE_WITHDRAWAL_FEATURE: true,
    SUPPORT_EMAIL: 'support@swiftramp.in',
  }
};

const config =configs.production;
export default config;
